import React from 'react';
import GoalDetailPanel from './GoalDetailPanel';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Ensures we don't try and fetch goals and users before we are logged in
const GoalDetailPanelWrapper = () => {
  const { isLoggedIn } = useCurrentUser();

  if (isLoggedIn) return <GoalDetailPanel />;
  return null;
};

export default GoalDetailPanelWrapper;
